import { render, staticRenderFns } from "./FunderTable.vue?vue&type=template&id=4e895fe4"
import script from "./FunderTable.vue?vue&type=script&lang=js"
export * from "./FunderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports